module.exports = __webpack_public_path__ + "Flag-28.a42b9f858d22fe7a897b2b976c5cc82b.svg";